import ArrowRight from '../../assets/icons/ArrowRight';
import { pageHeaders } from '../../misc/constants';

export const PageHeader = () => {
  const pathname = window.location.pathname;
  let meta = pageHeaders[pathname];
  if (!meta) {
    meta = Object.values(pageHeaders).find(
      (h) => h.match === 'param' && h.check(window.location.pathname)
    );
  }
  if (!!meta) {
    return (
      <div className="flex flex-row py-2.5 border-b-[0.5px] border-b-[#979797]">
        {meta.crumbs.map((crumb, index) => (
          <>
            <p
              className={`text-xl font-extrabold ${
                index === meta.crumbs.length - 1
                  ? 'text-[#202020]'
                  : 'text-[#979797]'
              }`}
            >
              {crumb}
            </p>
            {index !== meta.crumbs.length - 1 && (
              <ArrowRight additionalStyle="mx-1 text-gray-500" />
            )}
          </>
        ))}
      </div>
    );
  }
};
